import React from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';

const OrderKeysDevolutionComponent = ({ keysLocationInformation, handleOpenAddress }) => {
  const intl = useIntl();

  const devolutionType = keysLocationInformation?.keysDevolutionType;
  const devolutionAddress = keysLocationInformation?.keysDevolutionAddress;

  if (devolutionType === 'Outro' || devolutionType === 'Na imobiliária') {
    if (!devolutionAddress) {
      return intl.formatMessage({ id: devolutionType });
    }

    const fullAddress = `${devolutionAddress?.street}, ${devolutionAddress?.number}, ${devolutionAddress?.neighborhood}${
      devolutionAddress?.complement ? ` - ${devolutionAddress.complement}` : ''
    }, ${devolutionAddress?.city}/${devolutionAddress?.state}`;

    return (
      <button
        className="bg-none border-none underline text-[#5292cd]"
        type="button"
        onClick={() => handleOpenAddress(devolutionAddress)}
        title={fullAddress}
      >
        {fullAddress}
      </button>
    );
  }

  return intl.formatMessage({ id: devolutionType, defaultMessage: devolutionType });
};

OrderKeysDevolutionComponent.propTypes = {
  keysLocationInformation: PropTypes.object.isRequired,
  handleOpenAddress: PropTypes.func.isRequired,
};

export default OrderKeysDevolutionComponent;
